import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

export default function initSlider() {
    window.addEventListener('load', function () {

        const editMode =  document.body.classList.contains('has-edit-mode-menu');

        if (editMode){
            return;
        }

        const $containers = document.querySelectorAll('.slider-container');
        $containers.forEach($container => {
            const $slider = $container.querySelector('.swiper');
            let $sliderItems = 1;

            if ($container.classList.contains('custom-slider')) {
                const $wrapper = $container.querySelector('.swiper > div');
                $wrapper.classList.add('swiper-wrapper');

                const $slides = $container.querySelectorAll('.swiper > div > div');
                $slides.forEach($slide => {
                    $slide.classList.add('swiper-slide');
                });
            }

            // Initialize the slider
            const swiper = new Swiper($slider, {
                direction: 'horizontal',
                loop: true,
                observer: true,
                observerParents: true,
                watchOverflow: true,
                rewind: false,
                a11y: true,
                autoHeight: false,
                lazy: true,
                slidesPerView: 1,
                spaceBetween: 10,
                modules: [ Autoplay, Navigation ],
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    640: {
                        slidesPerView: $sliderItems,
                        spaceBetween: 20
                    }
                }
            });
        });
    });
}
